var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'fn-api-downloads': true}},[_c('div',{class:{'fn-api-download': true, 'active': _vm.show}},[_c('div',{staticClass:"fn-api-download--title"},[_vm._v(" Downloading \""+_vm._s(_vm.filename)+"\" ")]),_c('b-progress',{staticClass:"fn-api-downloads--download",attrs:{"value":_vm.progress,"max":100,"height":"5px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }